import { createStyles } from '@material-ui/styles'
const styles = ({ breakpoints }) =>
    createStyles({
        root: {
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            background: '#FFFFFF',
            padding: '20px 72px',
            [`@media (max-width:${breakpoints.values.md}px)`]: {
                padding: '46px 22px',
            },
        },
        signUpSuceess: {
            marginTop: '20px',
            fontSize: '26px',
            lineHeight: '30px',
            textAlign: 'center',
            fontWaight: 'bold',
            padding: '15px',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                textAlign: 'center',
                fontSize: '18px',
            },
        },
        signUpDesc: {
            margin: '33px 0 62px',
            fontSize: '21px',
            // textAlign: 'justify',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                fontSize: '14px',
                margin: '17px 0 28px',
            },
        },
        signUpNewLink: {
            marginTop: '5px',
            fontSize: '14px',
            lineHeight: '22px',
            
            '& span': {
                cursor: 'pointer',
                color: 'inherit',
            },
        },
        img: {
            marginTop: '50px',
            maxWidth: '100%',
            height: 'auto',
            '@media(max-width: 768px)': {
                marginTop: '50px',
                //width : "80%",
            },
        },
        stepper: {
            padding: '60px 25px 0px 0px',
        },
        membershipID: {
            marginTop: '20px',
            fontSize: '18px',
            '& .pipe': {
                borderLeft: '1px solid',
                margin: '0 10px',
            },
        },
        memberImg: {
            width: '414px',
            height: '72px',
            marginTop: '50px',
        },

        welcome: {
            fontWeight: '600',
            fontSize: '44px',
            color: '#75A4D3',
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                textAlign: 'center',
                fontSize: '24px',
            },
        },
        welcomeHeader: {
            color: '#153862',
            fontSize: '44px',
            fontStyle: 'normal',
            fontWeight: '600',
            '& .member': {
                fontFamily: 'FeelingPassionate',
                fontWeight: '400',
                position: 'relative',
                '& > img': {
                    position: 'absolute',
                    top: '-30px',
                    right: '-80px',
                    [`@media (max-width:${breakpoints.values.sm}px)`]: {
                        top: '-60px',
                        transform: 'scale(50%)',
                    },
                },
            },
            [`@media (max-width:${breakpoints.values.sm}px)`]: {
                textAlign: 'center',
                fontSize: '24px',
            },
        },
        button: {
            '& *': {
                width: '100%',
                textAlign: 'center',
            },
            '& button': {
                margin: '0 0 10px',
            },
            '& button span': {
                fontSize: '21px',
                fontWeight: 700,
                [`@media (max-width:${breakpoints.values.sm}px)`]: {
                    fontSize: '13px',
                },
            },
        },
    })
export default styles



// WEBPACK FOOTER //
// ./src/components/SignUpSuccessContainer/SignUpSuccess/signUpSuccessStyle.js